"use client";
import { CONTACT_US_DATA } from "@/lib/ConstData";
import { PhoneOutgoing } from "lucide-react";
import { useAnalytics } from "@/hooks/useAnalytics";
import { ContactAnalytics } from "@/lib/analyticsName";
import { track } from "@/lib/tracking";

const PhoneQueries = () => {
  const phoneNumber = CONTACT_US_DATA.phone;
  const { createClickHandler } = useAnalytics();

  // Create phone click handler with analytics
  const createPhoneHandler = () => {
    return createClickHandler(
      () => {
        track('phone_click', { source_page: document.title });
        window.open(`tel:${phoneNumber}`, "_self");
      },
      ContactAnalytics.Phone,
      ContactAnalytics.Category,
      {
        contact_type: 'phone',
        contact_value: phoneNumber,
        component: 'phone_queries_header',
        location: 'header'
      }
    );
  };

  return (
    <button 
      onClick={createPhoneHandler()}
      className="flex items-center justify-center w-full cursor-pointer" 
      role="button"
      tabIndex={0}
      aria-label="Contact us on phone"
    >
     <PhoneOutgoing className="w-4 h-4 md:w-5 md:h-5 !text-[#F05A24]" />
      <div className="flex md:block items-center justify-center ml-2">
        <p className="text-black text-[14px] md:text-[12px]">
          For any queries call on
        </p>
        <p className="!text-[#F05A24] text-[14px] md:text-[12px] ml-1 md:ml-0 font-bold text-left">
          {phoneNumber}
        </p>
      </div>
    </button>
  );
};

export default PhoneQueries;